import styled from "styled-components";
import {LiveCasinoFilterButtonIconDefaultBox} from "./live-casino-filter-button-icon.default.box";

export const LiveCasinoFilterIconMrGreenBox = styled(LiveCasinoFilterButtonIconDefaultBox)`
    transform: scale(1);
    color: ${({theme, isActiveTab}) => isActiveTab ? theme.colors.textActive : theme.colors.textLight};
`;